import { ICONS } from 'components/Icon';
import * as React from 'react';
import { NAVIGATE_MODAL } from 'store/actions';
import { ModalScreens } from 'components/Navigation/types';
import { useDispatch } from 'react-redux';
import { EngagePropertyListItem } from 'types/Engage';
import { pluralise } from 'lib/pluralise';
import { PageHeader } from 'components/PageHeader';
import { selectEngageIsLoadedEver } from 'store/remote/engageSelectors';
import { useSelector } from 'hooks/useSelector';

type Props = {
  onBackPress: () => void;
  property: EngagePropertyListItem;
  pageKey: string;
  scheduledVisitsCount: number;
};
export const ScheduledVisitsHeader: React.FC<Props> = ({
  onBackPress,
  property,
  pageKey,
  scheduledVisitsCount,
}) => {
  const dispatch = useDispatch();

  const isLoadedEver = useSelector((state) =>
    selectEngageIsLoadedEver(state, pageKey, 'scheduledVisits'),
  );

  const handleOpenScheduledVisitModal = React.useCallback(() => {
    dispatch(
      NAVIGATE_MODAL({
        screen: ModalScreens.EngageFlatDoorScheduledVisit,
        size: 'large',
        params: {
          propertyId: property.id,
          pageKey,
        },
      }),
    );
  }, [dispatch, property.id, pageKey]);

  return (
    <PageHeader
      showSidebarButton
      backButtonText="Engage"
      title={property.name}
      subtitle={
        !isLoadedEver
          ? 'Loading Scheduled Visits'
          : pluralise(
              scheduledVisitsCount,
              '{x} Scheduled Visit',
              '{x} Scheduled Visits',
              'No Scheduled Visits',
            )
      }
      onPressBackButton={onBackPress}
      saveButtonIcon={ICONS.PlusLight}
      onPressSaveButton={handleOpenScheduledVisitModal}
    />
  );
};
